export const TAKE_TOUR_BUTTON_TEST_ID = "takeTourButton";
